import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'
import { AutoComplete, Flex } from 'hljd'
import React, { Component, Fragment } from 'react'
import CheckInput from '../CheckInput'

const { Option } = AutoComplete
const FormItem = Form.Item

class Addr extends Component {
  onHotelChange = value => {
    const { hotels, setFieldsValue } = this.props
    const hotel = hotels.find(item => item.name == value)
    if (hotel) {
      setFieldsValue({
        hotel_id: hotel.merchantId,
        hotel_name: value
      })
    } else {
      setFieldsValue({
        hotel_id: '',
        hotel_name: value
      })
    }
  }

  render() {
    const {
      getFieldDecorator,
      hotels,
      formItemLayout,
      getFieldError,
      onSearchHotel,
      form_default
    } = this.props

    const options = hotels.map(({ name, city, areaName }) => {
      return (
        <Option key={name} value={name}>
          <Flex sp>
            <span>{name}</span>
            <span>
              {city}，{areaName}
            </span>
          </Flex>
        </Option>
      )
    })
    return (
      <Fragment>
        <FormItem label={'婚礼地点'} {...formItemLayout}>
          {getFieldDecorator('hotel_name', {
            initialValue: form_default.hotel_name || '',
            rules: [
              {
                required: true,
                message: '请填写婚礼地点'
              }
            ]
          })(
            <CheckInput
              autoComplete
              allowClear
              placeholder="请输入酒店/场地名称"
              dataSource={options}
              style={{ width: 440 }}
              onSearch={onSearchHotel}
              onChange={this.onHotelChange}
              getFieldError={getFieldError}
              optionLabelProp="value"
            />
          )}
        </FormItem>
      </Fragment>
    )
  }
}

export default Addr
